module.exports = __webpack_public_path__ + "static/media/ccArin.e65a1bd9.webp";